// src/services/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence, signInAnonymously } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { logger } from '../utils/logger';

/**
 * @file This file initializes Firebase and exports the Firebase services.
 */

const firebaseConfig = {
  apiKey: "AIzaSyD0swLYQOX-jbTqgh666geCd33ogBQEEfA",
  authDomain: "afterthewhistle.app",
  projectId: "after-the-whistle-97f96",
  storageBucket: "after-the-whistle-97f96.firebasestorage.app",
  messagingSenderId: "506432783407",
  appId: "1:506432783407:web:093a630f3c2e2c5ce772da",
  measurementId: "G-LG7HC8NSV8"
};

export const app = initializeApp(firebaseConfig);

if (process.env.NODE_ENV !== 'production') {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

initializeAppCheck(app, { 
  provider: new ReCaptchaV3Provider("6LeNMkorAAAAAHWWg6Hn1beiIEdEb5VHk3iV9-ez"),
  isTokenAutoRefreshEnabled: true
});

// Initialize Firebase services with better error handling
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Set default persistence to LOCAL (survives browser restart)
// This helps prevent the "white screen" issue after device lock/unlock
try {
  setPersistence(auth, browserLocalPersistence)
    .then(() => {
      logger.log('Firebase: Set default auth persistence to LOCAL');
    })
    .catch((error) => {
      logger.error('Firebase: Error setting persistence:', error);
    });
} catch (error) {
  logger.error('Firebase: Error setting up persistence:', error);
}

// Remove emulator connection entirely
// We're not using emulators in this application

// Firebase auth persistence is already set above, no need for a duplicate call here

/**
 * Signs the user in as a guest.
 *
 * @returns {Promise<UserCredential>} A promise that resolves with the user credential.
 */
export const signInAsGuest = async () => {
  try {
    const userCredential = await signInAnonymously(auth);
    logger.log("Signed in as guest:", userCredential.user);
    return userCredential;
  } catch (error) {
    logger.error("Error signing in as guest:", error);
    throw error;
  }
};
